import {ICategoryNode} from 'modules/categories/models/CategoryTree';
import {ICategoriesState} from 'modules/categories/types';
import {createContext} from 'react';

interface ICategoryPageContextProps {
    category: ICategoryNode;
    isLoading?: boolean;
    productsListPerCategory?: ICategoriesState['productPreviewList'];
}

interface ISeoCategoryPageContextProps {
    categoriesTree: ICategoryNode[];
}

export const CategoryPageContext = createContext<ICategoryPageContextProps>({} as ICategoryPageContextProps);

export const CategoryPageLayoutContext = createContext<ICategoryPageContextProps>({} as ICategoryPageContextProps);

export const CategorySeoPageContext = createContext<ISeoCategoryPageContextProps>({
    categoriesTree: [],
});
